module.exports = "pegasus/assets/themelp1/design/100.png";